import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styles from './license-payment-confirm.module.scss';
import { ModalWindow, DefaultButton, Alert } from 'shared/ui';
import { LicenseEnum } from 'shared/types';
import { BusinessApi } from 'shared/api';
import { AppLinks } from 'app/router/consts/app-links.enum';

interface ILicensePaymentConfirmProps {
  toEmplCount: number;
  monthCount: number;
  totalPrice: number;
  totalDiscount: number;
  licType: LicenseEnum;
  onClose: () => void;
}

export const LicensePaymentConfirm: React.FC<ILicensePaymentConfirmProps> = ({
  toEmplCount,
  monthCount,
  totalPrice,
  totalDiscount,
  licType,
  onClose,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handlePay = async () => {
    setLoading(true);
    setError(null);
    try {
      const paymentLink = await BusinessApi.licensePayment({
        licCountEmployees: toEmplCount,
        licExpireMonths: monthCount,
      });
      window.location.replace(paymentLink);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка оплаты');
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const licTypeLabel = licType === LicenseEnum.BASE ? 'Базовая' : 'Бесплатно';

  return (
    <ModalWindow onClickOutside={() => onClose()}>
      <div className={styles.card}>
        <h2 className={styles.title}>Подтверждение оплаты</h2>

        <div className={styles.details}>
          <div className={styles.row}>
            <span className={styles.label}>Тариф</span>
            <span className={styles.value}>{licTypeLabel}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Сотрудников</span>
            <span className={styles.value}>{toEmplCount}</span>
          </div>
          <div className={styles.row}>
            <span className={styles.label}>Месяцев</span>
            <span className={styles.value}>{monthCount}</span>
          </div>
          {totalDiscount > 0 && (
            <div className={styles.row}>
              <span className={styles.label}>Скидка</span>
              <span className={styles.value}>{totalDiscount}%</span>
            </div>
          )}
          <div className={`${styles.row} ${styles.totalRow}`}>
            <span className={styles.label}>Итого</span>
            <span className={styles.value}>{totalPrice} ₽</span>
          </div>
        </div>

        <div className={styles.actions}>
          <DefaultButton
            buttonText="Отмена"
            onClick={handleCancel}
            color="red"
            disabled={loading}
          />
          <DefaultButton
            buttonText="Оплатить"
            onClick={handlePay}
            color="green"
            disabled={loading}
          />
        </div>

        <div className={styles.offer}>
          Нажимая «Оплатить», вы принимаете условия{' '}
          <Link
            to={AppLinks.LicenseAgreementLink}
            className={styles.offer__link}
          >
            публичной оферты
          </Link>
        </div>
      </div>

      {error && (
        <Alert type="error" message={error} onClose={() => setError(null)} />
      )}
    </ModalWindow>
  );
};
